export const parsedToken = (parToken) => {
    return parToken.auth_token;
};
export const getAccountCodeFromToken = (parToken) => {
    var _a, _b, _c, _d, _e, _f;
    return (((_a = parToken === null || parToken === void 0 ? void 0 : parToken.Ai) === null || _a === void 0 ? void 0 : _a.trim()) ||
        ((_b = parToken === null || parToken === void 0 ? void 0 : parToken.CAi) === null || _b === void 0 ? void 0 : _b.trim()) ||
        ((_d = (_c = parToken === null || parToken === void 0 ? void 0 : parToken.user) === null || _c === void 0 ? void 0 : _c.Ai) === null || _d === void 0 ? void 0 : _d.trim()) ||
        ((_f = (_e = parToken === null || parToken === void 0 ? void 0 : parToken.user) === null || _e === void 0 ? void 0 : _e.CAi) === null || _f === void 0 ? void 0 : _f.trim()));
};
export const getLgSrc = (parToken) => {
    return parToken.lgnSrc ? parToken.lgnSrc : parToken.src;
};
export const getIsImpersonatedFromToken = (parToken) => {
    return parToken.isImpersonated;
};
export const getaccTypeFromToken = (parToken) => {
    return parToken.accType;
};
//iFrame is used in sales-journey
export const getIsInIFrame = () => {
    let inIframe = false;
    try {
        inIframe = window.self !== window.top;
    }
    catch (e) {
        //for catch cross origin
        inIframe = true;
    }
    return inIframe;
};
export const getEmailFromToken = (parToken) => { var _a; return (_a = parToken.email) !== null && _a !== void 0 ? _a : ""; };
